<script>
import BudgetCallWidget from "@/components/widgets/budget-call-widget.vue";

export default {
    page: {
        title: "Budget Call",
    },
    components: {
        BudgetCallWidget,
    },
};
</script>

<template>
    <BudgetCallWidget viewFrom="finance" />
</template>